type UpvalueIntroUser =
    | {
          options?: {
              has_seen_upvalue_intro?: boolean
              has_seen_paid_upvalue_intro?: boolean
              has_seen_seed_intro?: boolean
          }
      }
    | null
    | undefined

export const shouldShowFreeUpvalueIntro = (
    currentUser: UpvalueIntroUser,
    introModalOpen: boolean,
) => Boolean(currentUser && !currentUser.options?.has_seen_upvalue_intro && !introModalOpen)

export const shouldInterceptPaidUpvalueIntro = (currentUser: UpvalueIntroUser) =>
    Boolean(currentUser && !currentUser.options?.has_seen_paid_upvalue_intro)

export const shouldInterceptSeedIntro = (currentUser: UpvalueIntroUser) =>
    Boolean(currentUser && !currentUser.options?.has_seen_seed_intro)
